export default {
    items: [
        {
            name: 'Путевки',
            url: '/manager/vouchers',
            icon: 'icon-briefcase'
        },
        {
            name: 'Брони',
            url: '/manager/bookings',
            icon: 'fa fa-calendar-check-o'
        },
        {
            name: 'Квоты',
            url: '/manager/quotas',
            icon: 'icon-pie-chart'
        },
        // {
        //     name: 'Оформлятор', // НСБ › Агентство › ПУТЕВКИ КМВ (Оформлятор)
        //     url: '/manager/oformlyator',
        //     icon: 'icon-puzzle'
        // },
        {
            name: 'Заезды',
            url: '/manager/checkins',
            icon: 'fa fa-taxi'
        },
        {
            name: 'Объекты отдыха',
            url: '/tech/hotels',
            icon: 'icon-puzzle',
        },
        {
            name: 'Компании',
            url: '/admin/companies',
            icon: 'icon-people'
        },
    ]
}
